module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-col', {
    attrs: {
      "sm": 12
    }
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h2', {}, [_vm._v("Yhteyshenkilöt")])]), _vm._v(" "), (_vm.contactsByDistrict.length > 0) ? _c('div', _vm._l((_vm.contactsByDistrict), function(contact) {
    return _c('div', [_c('contact', {
      attrs: {
        "contact": contact,
        "changedValues": _vm.changedValues[contact.id]
      },
      on: {
        "update:changedValues": function($event) {
          var $$exp = _vm.changedValues,
            $$idx = contact.id;
          if (!Array.isArray($$exp)) {
            _vm.changedValues[contact.id] = $event
          } else {
            $$exp.splice($$idx, 1, $event)
          }
        }
      }
    })], 1)
  })) : _vm._e(), _vm._v(" "), _c('el-button', {
    staticClass: "add",
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": _vm.addContact
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ec1e03e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Contacts.vue
// module id = 450
// module chunks = 0